import { render } from "./CostoCreate.vue?vue&type=template&id=018454ac&scoped=true"
import script from "./CostoCreate.vue?vue&type=script&lang=js"
export * from "./CostoCreate.vue?vue&type=script&lang=js"

import "./CostoCreate.vue?vue&type=style&index=0&id=018454ac&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-018454ac"]])

export default __exports__